<template>
  <div>
    <app-header :title="getLabel('FOUR_SEASONS_VOUCHER_INSPECTOR')" />
    <b-container>
      <b-row>
        <b-col>
          <b-form inline @submit.stop.prevent="lookup()">
            <label class="mr-2" v-label-key="'FOUR_SEASONS_VOUCHER_ID'"
              >Voucher ID</label
            >
            <b-input v-model="codeId" type="text" />
            <b-button variant="light" type="submit" class="ml-2">
              <span v-label-key="'GO'">Go</span>
            </b-button>
          </b-form>
          <b-table-simple v-if="code" striped class="mt-5">
            <b-tr>
              <b-td><span v-label-key="'ID'">ID</span></b-td>
              <b-td>{{ code.id }}</b-td>
            </b-tr>
            <b-tr>
              <b-td
                ><span v-label-key="'FOUR_SEASONS_PACK_ID'">Pack ID</span></b-td
              >
              <b-td>{{ code.fspack_id }}</b-td>
            </b-tr>
            <b-tr>
              <b-td><span v-label-key="'CREATED'">Created</span></b-td>
              <b-td>{{ code.created | moment('YYYY-MM-DD') }}</b-td>
            </b-tr>
            <b-tr>
              <b-td
                ><span v-label-key="'PURCHASE_DETAILS'"
                  >Purchase Details</span
                ></b-td
              >
              <b-td>
                {{ purchaseDetailsMessage(code) }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td><span v-label-key="'USAGE'">Usage</span></b-td>
              <b-td v-if="!code.used">
                <span v-label-key="'NOT_USED'">Not Used</span>
              </b-td>
              <b-td v-if="code.used">
                {{ usageDetailsMessage(code) }}
              </b-td>
            </b-tr>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import $auth from '@/services/auth';
import { mapGetters } from 'vuex';

export default {
  components: {
    AppHeader,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
      getReplaceLabel: 'getReplaceLabel',
    }),
    purchaseDetailsMessage() {
      return code => {
        const messageNoNumber = 'PURCHASE_DETAILS_MESSAGE';
        const messageWithNumber = 'PURCHASE_DETAILS_MESSAGE_CUSTOMER_NUMBER';
        const messageKey =
          this.auth.user.selectedAccess.roleLevel > 3
            ? messageWithNumber
            : messageNoNumber;
        const replacements = {
          '{CUSTOMER_NUMBER}': code.customer_number,
          '{CHAIN_NAME}': code.purchase_chain_name,
          '{CHAIN_ID}': code.purchase_chain_id,
          '{STORE_NAME}': code.purchase_store_name,
          '{STORE_ID}': code.purchase_store_id,
          '{PURCHASE_DATE}': this.$moment(code.created).format('YYYY-MM-DD'),
        };
        return this.getReplaceLabel(messageKey, replacements);
      };
    },
    usageDetailsMessage() {
      return code => {
        const messageNoNumber = 'USAGE_DETAILS_MESSAGE';
        const messageWithNumber = 'USAGE_DETAILS_MESSAGE_CUSTOMER_NUMBER';
        const messageKey =
          this.auth.user.selectedAccess.roleLevel > 3
            ? messageWithNumber
            : messageNoNumber;
        const replacements = {
          '{CUSTOMER_NUMBER}': code.owner_number,
          '{STORE_NAME}': code.used_store_name,
          '{STORE_ID}': code.used_store,
          '{USAGE_DATE}': this.$moment(code.used_time).format('YYYY-MM-DD'),
        };
        return this.getReplaceLabel(messageKey, replacements);
      };
    },
  },
  data() {
    return {
      codeId: null,
      code: null,
      auth: $auth,
    };
  },
  methods: {
    lookup() {
      $api.get(`/v1/dashboard/fsvouchers/${this.codeId}`).then(code => {
        if (!code) {
          alert('Invalid code'); // eslint-disable-line no-alert
        }
        this.code = code;
      });
    },
  },
};
</script>
